import React from 'react';

import Header from '../../Components/Dashboard/Header/Header';
import Reports from '../../Components/Dashboard/Admin/Reports/List.js';


export default function ReportsPage() {
  return (
    <>
      <Header/>
      <div className="body">
        <Reports/>
      </div>
    </>
  );
}
